import './LoadingIndicator.css';

export default function LoadingIndicator({height}) {
    return <div className='loading-indicator-container'>
        <div className='loading-indicator' style={{ height:`${height}em`}}>
            <img loading="lazy" src='/images/loading-wheel.webp' alt="Ładowanie..." />

        </div>
    </div>;
}
